export default __webpack_public_path__ + "static/media/instagram.70ea3cbc.svg";